import { SeoConfig } from '@domgen/dgx-fe-seo';
import { AppConfig } from '../../models/config/app-config.type';

export const seoConfigFactory = (config: AppConfig): SeoConfig => ({
  baseUrl: config.canonicalBaseUrl,
  titleSuffix: config.clientName,
  hostUrl: config.canonicalBaseUrl,
});
